import { render } from "./LoginSetting.vue?vue&type=template&id=3a4b014f"
import script from "./LoginSetting.vue?vue&type=script&lang=js"
export * from "./LoginSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__